import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ServicesPreview from './components/ServicesPreview';
import About from './components/About';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import Vision from './components/Vision';
import WhyChoose from './components/WhyChoose';
import QA from './components/QA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AccessibilityMenu from './components/AccessibilityMenu';
import './App.css';

function App() {
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <ServicesPreview />
        <About />
        <Vision />
        <WhyChoose />
        <Projects />
        <Testimonials />
        <QA />
        <Contact />
        <Footer />
      </div>
      <AccessibilityMenu />
    </>
  );
}

export default App;
